// extracted by mini-css-extract-plugin
export default {"container":"Accessibility_container__piKjd","icon":"Accessibility_icon__w+hJ-","off":"Accessibility_off__bRbNF"};